(() => {
  const ROOT_SELECTOR = '[data-pianzi-cart-agreement]';
  const STORAGE_KEY = 'pianzi-cart-agreement-accepted';
  const initialized = new WeakSet();

  function storedAccepted() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function storeAccepted(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
    } catch (error) {
      // Storage may be unavailable in strict privacy modes.
    }
  }

  function getContainer(root) {
    return root.closest('cart-drawer, #main-cart-footer, .cart__footer-wrapper, .shopify-section') || document;
  }

  function getCheckoutButtons(root) {
    const container = getContainer(root);
    return Array.from(container.querySelectorAll('[data-pianzi-checkout-button], button[name="checkout"]'));
  }

  function update(root, accepted, announce = false) {
    const checkbox = root.querySelector('[data-pianzi-cart-agreement-checkbox]');
    if (!checkbox) return;

    checkbox.checked = Boolean(accepted);
    root.classList.toggle('is-invalid', announce && !accepted);
    root.dataset.accepted = accepted ? 'true' : 'false';

    getCheckoutButtons(root).forEach((button) => {
      button.disabled = !accepted;
      button.setAttribute('aria-disabled', accepted ? 'false' : 'true');
    });

    if (accepted) storeAccepted(true);
  }

  function initialize(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const checkbox = root.querySelector('[data-pianzi-cart-agreement-checkbox]');
    if (!checkbox) return;

    const accepted = storedAccepted();
    update(root, accepted);

    checkbox.addEventListener('change', () => {
      update(root, checkbox.checked);
      if (!checkbox.checked) storeAccepted(false);
    });
  }

  function initializeAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  }

  function findAgreementForButton(button) {
    const container = button.closest('cart-drawer, #main-cart-footer, .cart__footer-wrapper, .shopify-section') || document;
    return container.querySelector(ROOT_SELECTOR);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-pianzi-checkout-button], button[name="checkout"]');
    if (!button) return;

    const root = findAgreementForButton(button);
    if (!root) return;

    const checkbox = root.querySelector('[data-pianzi-cart-agreement-checkbox]');
    if (checkbox?.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    update(root, false, true);
    checkbox?.focus({ preventScroll: true });
    root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    const root = findAgreementForButton(submitter);
    const checkbox = root?.querySelector('[data-pianzi-cart-agreement-checkbox]');
    if (!root || checkbox?.checked) return;

    event.preventDefault();
    update(root, false, true);
    checkbox?.focus();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

  const observer = new MutationObserver((mutations) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.classList.contains('is-empty')) storeAccepted(false);

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initializeAll(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
